/**
 * Search forms JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class SearchForms
 */
class SearchForms {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Form fields and the submit button for form handling
        this.searchForm          = $( '#site-searchform--projects' );
        this.checkboxFields      = this.searchForm.find( 'input[type="checkbox"]' );
        this.inputTextFields     = this.searchForm.find( 'input[type="text"]' );
        this.inputKeywords       = this.searchForm.find( '.searchform__input' );
        this.projectTextField    = this.searchForm.find( '.project-search' );
        this.selectField         = this.searchForm.find( 'select' );
        this.selectArea          = this.searchForm.find( '#select-area' );
        this.selectType          = this.searchForm.find( '#select-types' );
        this.selectOrganization  = this.searchForm.find( '#select-organization' );
        this.selectPortfolio     = this.searchForm.find( '#select-portfolio' );
        this.selectMainFinancier = this.searchForm.find( '#select-mainfinancier' );
        this.selectStatus        = this.searchForm.find( '#select-status' );
        this.submitButton        = $( '#js-submit-button--projects' );

        this.submitOkText      = $( '#site-searchform--projects .searchform__submit__text' );
        this.submitBlockedText = $( '#site-searchform--projects .searchform__submit__blocked' );

        // To check if any of the fields have a value
        this.hasValue = false;

        // To check if any of the fields have a value or is actively selected
        this.hasSelection = false;

        // Get the string for when nothing is selected from municipalities - also get the actual word for municipalities
        this.municipalitiesSlug = themeData.themeStrings.municipalities_slug;
        this.municipality       = themeData.themeStrings.municipality;

        // Choose type - to see if a type has been selected
        this.chooseType = themeData.themeStrings.choose_type;
        this.typesSlug  = themeData.themeStrings.types_slug;

        // Get the value and the string for an organization dropdowns default state
        this.chooseOrganization = themeData.themeStrings.organization;
        this.organizationSlug   = themeData.themeStrings.organization_slug;

        // Get the value and the string for a portfolio dropdowns default state
        this.choosePortfolio = themeData.themeStrings.project.portfolio;
        this.portfolioSlug   = themeData.themeStrings.portfolio_slug;

        // Get the value and the string for a main financier dropdowns default state
        this.chooseMainFinancier = themeData.themeStrings.project.main_financier;
        this.mainFinancierSlug   = themeData.themeStrings.mainfinancier_slug;

        // Get the value and the string for a status dropdowns default state
        this.chooseStatus = themeData.themeStrings.project.status;
        this.statusSlug   = themeData.themeStrings.status_slug;

        // Get type, area, portfolio, mainfinancier, status and organization strings
        this.type          = themeData.themeStrings.queries.type;
        this.area          = themeData.themeStrings.queries.area;
        this.organization  = themeData.themeStrings.queries.organization;
        this.portfolio     = themeData.themeStrings.queries.portfolio;
        this.mainfinancier = themeData.themeStrings.queries.mainfinancier;
        this.status        = themeData.themeStrings.queries.status;

        // Get the date strings for readspeakers
        this.day         = themeData.themeStrings.search.day;
        this.today       = themeData.themeStrings.search.today;
        this.tomorrow    = themeData.themeStrings.search.tomorrow;
        this.thisWeekend = themeData.themeStrings.search.this_weekend;
        this.startDay    = themeData.themeStrings.search.start_day;
        this.endDay      = themeData.themeStrings.search.end_day;

        // An array for aria live
        this.ariaFiltersWrap      = $( '#js-aria-live-filters' );
        this.arialiveTypes        = this.ariaFiltersWrap.find( '.aria-live-types' );
        this.arialiveArea         = this.ariaFiltersWrap.find( '.aria-live-area' );
        this.arialiveOrganization = this.ariaFiltersWrap.find( '.aria-live-organization' );
        this.arialiveInput        = this.ariaFiltersWrap.find( '.aria-live-input' );
        this.arialiveDay          = this.ariaFiltersWrap.find( '.aria-live-day' );
        this.arialiveStartDate    = this.ariaFiltersWrap.find( '.aria-live-startdate' );
        this.arialiveEndDate      = this.ariaFiltersWrap.find( '.aria-live-enddate' );
        this.ariaFiltersArray     = [];
        this.typeFiltersString    = '';

        // Buttons to control the datepickers
        this.buttonToday      = $( '#js-today-button' );
        this.buttonTomorrow   = $( '#js-tomorrow-button' );
        this.buttonOnWeekend  = $( '#js-weekend-button' );
        this.allButtons       = $( '.datepicker-button' );

        // Date pickers
        this.eventStart       = $( '#datepicker-start' );
        this.eventEnd         = $( '#datepicker-end' );
        this.allDatepickers   = $( '.datepickers__input' );
        this.eventStartHidden = $( '#js-datepicker-start-hidden' );
        this.eventEndHidden   = $( '#js-datepicker-end-hidden' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // For blocking the basic search function if no arguments are passed in the search fields
        this.submitButton.on( 'click', ( e ) => {

            // Do not allow searches without any filters selected
            if ( this.submitButton.hasClass( 'unclickable' ) )  {
                Theme.Common.stop( e );
            }
        });

        // If there is a select field selected when reloading the page, set it to be read in aria-live
        const selectedValue =  this.arialiveArea.find( ':selected' ).text();
        this.ariaController( 'aria-area', selectedValue );

        // Check if the select has a value selected to run the value checker function
        this.selectField.change( ( e ) => {

            // Fill the aria live wrap
            const selectedValue = $( e.currentTarget ).find( ':selected' ).text();

            if ( $( e.currentTarget ).hasClass( 'types-select' ) ) {
                this.ariaController( 'aria-types', selectedValue );

            } else if ( $( e.currentTarget ).hasClass( 'organization-select' ) ) {
                this.ariaController( 'aria-organization', selectedValue );

            } else {
                this.ariaController( 'aria-area', selectedValue );
            }

            // If any of the input fields has a value, set valueChecker to true
            this.valueChecker();
        });

        // Check if any fields have values while toggling the checkbox fields
        this.checkboxFields.each( ( index, field ) => {

            // On load, build aria live array to check which fields are selected
            if ( $( field ).is( ':checked' ) ) {
                const selectedCheckbox = $( field ).siblings( 'label' ).text();
                this.ariaFiltersArray.push( selectedCheckbox );
                this.typeFiltersString =  this.type + ': ' + this.ariaFiltersArray.join( ', ' ) + '.';

                // Pass the types to ariaController function, to build an aria-live string
                this.ariaController( 'aria-types', this.typeFiltersString );
            }

            // In real time, check if there is a change in the checkboxes
            $( field ).change( ( e ) => {

                // Get the text of the checked value and build a string from all the current checked values
                // to be passed to ariaController function
                const selectedCheckbox = $( e.currentTarget ).siblings( 'label' ).text();

                // Check if current filter is already in the array
                if ( $.inArray( selectedCheckbox, this.ariaFiltersArray ) > -1 ) {

                    // Splice array to get rid of current filter
                    this.ariaFiltersArray.splice( $.inArray( selectedCheckbox, this.ariaFiltersArray ), 1 );

                    // Check if array is not empty after splice. If not, show it.
                    if ( $( this.ariaFiltersArray ).length ) {

                        // Build a string to show to screen readers.
                        this.typeFiltersString =  this.type + ': ' + this.ariaFiltersArray.join( ', ' ) + '.';
                    } else {
                        this.typeFiltersString = '';
                    }

                } else {
                        this.ariaFiltersArray.push( selectedCheckbox );

                        // Build a string to show to screen readers
                        this.typeFiltersString =  this.type + ': ' + this.ariaFiltersArray.join( ', ' ) + '.';
                }

                // Pass the types to ariaController function, to build an aria-live string
                this.ariaController( 'aria-types', this.typeFiltersString );

                // If any of the fields has a value, set valueChecker to true
                this.valueChecker();

            });
        });

        // Check if there is a value while editing the free search field
        this.inputTextFields.each( ( index, field ) => {

            // On page load, set the value to aria live wrapper. Check if the input field is for keywords or dates
            const inputValue = $( field ).val();

            if ( $( field ).not( '.datepickers__input' ) ) {
                this.ariaController( 'aria-input', inputValue );
            }

            // In real time, check if there is a value in the input field when typing.
            $( field ).keyup( ( e ) => {

                // If any of the input fields has a value, set valueChecker to true, if not, false
                this.valueChecker();
            });

            // On keyword search focusout, update the aria-live container
            this.inputKeywords.focusout( ( e ) => {
                const inputValue = $( e.currentTarget ).val();
                this.ariaController( 'aria-input', inputValue );
            });

            // On datepickers focusout, update the correct aria live container
            this.eventStart.on( 'change',  ()=>  {
                const inputValue = this.eventStart.val();
                this.ariaController( 'aria-startdate', inputValue );
            });

            this.eventEnd.on( 'change',  ()=>  {
                const inputValue = this.eventEnd.val();
                this.ariaController( 'aria-enddate', inputValue );
            });

        });

        // Event search forms buttons to control the time window
        // Today -button - set the time window from today to today
        this.buttonToday.on( 'click', ( e ) => {

            Theme.Common.stop( e );

            this.eventStart.datepicker( 'setDate', 'today' );
            this.eventEnd.datepicker( 'setDate', 'today' );

            // Control the date button classes.
            this.controlDatepickerButtons( this.buttonToday );

            // Set correct strings for screenreaders
            this.ariaController( 'aria-day', this.today );

            // If any of the input fields has a value, set valueChecker to true, if not, false
            this.valueChecker();

        });

         // Tomorrow -button - set the time window from tomorrow to tomorrow
         this.buttonTomorrow.on( 'click', ( e ) => {

            Theme.Common.stop( e );

            this.eventStart.datepicker( 'setDate', '+1' );
            this.eventEnd.datepicker( 'setDate', '+1' );

            // Control the date button classes.
            this.controlDatepickerButtons( this.buttonTomorrow );

            // Set correct strings for screenreaders
            this.ariaController( 'aria-day', this.tomorrow );

            // If any of the input fields has a value, set valueChecker to true, if not, false
            this.valueChecker();

        });

        // On weekend -button - set the time window from next friday to sunday.
        this.buttonOnWeekend.on( 'click', ( e ) => {

            Theme.Common.stop( e );

            const date = new Date();

            // Current day of the week is Saturday.
            if ( ( date.getDay() == 6 ) ) {
                this.eventStart.datepicker( 'setDate', '-1d' );
            } else if ( ( date.getDay() == 0 ) ) { // Current day of the week is Sunday.
                this.eventStart.datepicker( 'setDate', '-2d' );
            } else { // Current day of the week is something between Monday and Friday.
                this.eventStart.datepicker( 'setDate', this.getNextDayOfWeek( '5' ) );
            }

            this.eventEnd.datepicker( 'setDate', this.getNextDayOfWeek( '7' ) );

            // Control the date button classes.
            this.controlDatepickerButtons( this.buttonOnWeekend );

            // Set correct strings for screenreaders
            this.ariaController( 'aria-day', this.thisWeekend );

            // If any of the input fields has a value, set valueChecker to true, if not, false
            this.valueChecker();
        });

        // Clear the active date button filters when calendars are changed manually
        this.allDatepickers.on( 'change', ( e ) => {
            this.allButtons.removeClass( 'datepicker-button--active' );

            // If any of the input fields has a value, set valueChecker to true, if not, false
            this.valueChecker();
        });
    }

    /**
     * Check if any field has a value
     */
     valueChecker() {

        // Get the selected municipality value
        const municipality = this.selectArea.find( ':selected' ).val();

        // Get the selected type value from type dropdown in event search
        const type = this.selectType.find( ':selected' ).val();

        // Get the selected organization value from organization dropdown in contact search
        const organization = this.selectOrganization.find( ':selected' ).val();

        // Get the selected portfolio value from type dropdown in project search
        const portfolio = this.selectPortfolio.find( ':selected' ).val();

        // Get the selected main financier value from type dropdown in project search
        const mainfinancier = this.selectMainFinancier.find( ':selected' ).val();

        // Get the selected status value from type dropdown in project search
        const status = this.selectStatus.find( ':selected' ).val();

        // Get the amount of checked checkboxes
        const filters = $( '.searchform__filters__single__checkbox:checked' );

        // Check if any filters are checked, if anything is selected from select or if the input field has a value
        if ( filters.length > 0 ) {
            this.hasValue = true;
        } else if ( municipality !== this.municipalitiesSlug && municipality !== undefined ) {
            this.hasValue = true;
        } else if ( type !== this.typesSlug && type !== undefined ) {
            this.hasValue = true;
        } else if ( this.inputTextFields.val() !== '' && ! this.inputTextFields.hasClass( 'project-search' )  ) {
            this.hasValue = true;
        } else if ( this.projectTextField.val() !== '' ) {
            this.hasSelection = true;
        } else if ( $( this.eventStart ).val() !== '' && $( this.eventStart ).val() !== undefined ) {
            this.hasValue = true;
        } else if ( $( this.eventEnd ).val() !== '' && $( this.eventEnd ).val() !== undefined ) {
            this.hasValue = true;
        } else if ( organization !== this.organizationSlug && organization !== undefined ) {
            this.hasValue = true;
        } else if ( portfolio !== this.portfolioSlug && portfolio !== undefined ) {
            this.hasSelection = true;
        } else if ( mainfinancier !== this.mainFinancierSlug && mainfinancier !== undefined ) {
            this.hasSelection = true;
        } else if ( status !== this.statusSlug && status !== undefined ) {
            this.hasSelection = true;
        } else {
            this.hasValue = false;
            this.hasSelection = false;
        }

        // Check if the submit button should be blocked
        this.blockSubmitButton();
     }

    /**
     *  Make submit unclickable before form is filled
     */
    blockSubmitButton() {
        if ( this.hasValue == false ) {
            this.submitButton.addClass( 'unclickable' );

            // Set the correct text
            this.submitBlockedText.removeClass( 'js-hidden' );
            this.submitOkText.addClass( 'js-hidden' );
        } else {
            this.submitButton.removeClass( 'unclickable' );

            // Set the correct text
            this.submitBlockedText.addClass( 'js-hidden' );
            this.submitOkText.removeClass( 'js-hidden' );

        }

        if ( this.hasSelection == false ) {
            this.submitButton.addClass( 'hide' );
            this.submitButton.addClass( 'unclickable' );

            // Set the correct text
            this.submitBlockedText.removeClass( 'js-hidden' );
            this.submitOkText.addClass( 'js-hidden' );
        } else {
            this.submitButton.removeClass( 'hide' );
            this.submitButton.removeClass( 'unclickable' );

            // Set the correct text
            this.submitBlockedText.addClass( 'js-hidden' );
            this.submitOkText.removeClass( 'js-hidden' );

        }
    }

    /**
     * A function to control the aria live -field
     *
     * @param {string} type
     * @param {string} keywords
     */
    ariaController( type, keywords ) {

        // Check the content type and fill the aria-live wrap with the current contents
        if ( type == 'aria-area' ) {

            // Check if the area type is set
            if ( keywords !== this.municipality && keywords.length > 0 ) {
                this.arialiveArea.text( this.area + ': ' + keywords  + '. ' );
            } else {
                this.arialiveArea.empty();
            }

        // Checkbox fields values for types
        } else if ( type == 'aria-types' ) {

            if ( keywords !== this.chooseType ) {
                this.arialiveTypes.text( keywords );
            } else {
                this.arialiveTypes.empty();
            }

        // Check if organization dropdown was changed
        } else if ( type == 'aria-organization' ) {

            // Check if the organization type is set
            if ( keywords !== this.chooseOrganization && keywords.length > 0 ) {
                this.arialiveOrganization.text( this.organization + ': ' + keywords  + '. ' );
            } else {
                this.arialiveOrganization.empty();
            }

        // Input field value from keyword search
        } else if ( type == 'aria-input' ) {
            this.arialiveInput.text( keywords );

        // Day buttons value
        } else if ( type == 'aria-day' ) {
            this.arialiveDay.text( this.day + ': ' + keywords );
            this.arialiveStartDate.empty();
            this.arialiveEndDate.empty();

        // Start date fields value
        } else if ( type == 'aria-startdate' ) {

            if ( keywords !== '' ) {
                this.arialiveStartDate.text( this.startDay + ': ' + keywords );
                this.arialiveDay.empty();
            } else {
                this.arialiveStartDate.empty();
            }

            // Also populate the end day in case it has a value
            if ( this.eventEnd.val() ) {
                this.arialiveEndDate.text( this.endDay + ': ' + this.eventEnd.val() );
            }

        // End date fields value
        } else if ( type == 'aria-enddate' ) {

            if ( keywords !== '' ) {
                this.arialiveEndDate.text( this.endDay + ': ' + keywords );
                this.arialiveDay.empty();
            } else {
                this.arialiveEndDate.empty();
            }

            // Also populate the end day in case it has a value
            if ( this.eventStart.val() ) {
                this.arialiveStartDate.text( this.startDay + ': ' + this.eventStart.val() );
            }

        }

    }

    /**
     * Create datepickers from input fields with jquery ui
     */
    createDatepickers() {

        var currentLang = document.documentElement.lang;

        this.eventStart.datepicker({
            altField: this.eventStartHidden,
            altFormat: 'yy-mm-dd',
            dateFormat: 'd.m.yy',
            regional: 'fi'
        });

        this.eventEnd.datepicker({
            altField: this.eventEndHidden,
            altFormat: 'yy-mm-dd',
            dateFormat: 'd.m.yy',
            regional: 'fi'
        });

        if ( currentLang == 'en-GB' ) {
            $.datepicker.setDefaults( $.datepicker.regional['en-GB']);
        } else if ( currentLang == 'fi' ) {
            $.datepicker.setDefaults( $.datepicker.regional.fi );
        } else if ( currentLang == 'sv-SE' ) {
            $.datepicker.setDefaults( $.datepicker.regional.sv );
        }

    }

    /**
     * Control the active classes on datepickers date buttons
     *
     * @param {object} clickedButton current clicked date button
     */
    controlDatepickerButtons( clickedButton ) {

        // Remove all date values if the clicked button was already active
        if ( clickedButton.hasClass( 'datepicker-button--active' ) ) {
            this.allButtons.removeClass( 'datepicker-button--active' );
            this.allDatepickers.val( '' );

        } else {

            // If clicked button was not active when clicked, make it one now
            this.allButtons.removeClass( 'datepicker-button--active' );
            clickedButton.addClass( 'datepicker-button--active' );
        }
    }

    /**
     * Get the date for a wanted weekday, the n:th weekday
     *
     * @param {number} dayOfWeek 1-7, the day wanted to find, 1 being monday
     */
    getNextDayOfWeek( dayOfWeek ) {

        // Create the new date and find out the next n:th date
        let wantedDate = new Date();
        wantedDate.setDate( wantedDate.getDate() + ( 7 + dayOfWeek - wantedDate.getDay() ) % 7 );

        return wantedDate;
    }


    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.valueChecker();
        this.blockSubmitButton();
        this.createDatepickers();
    }
}

// Export the class reference.
module.exports = SearchForms;



// WEBPACK FOOTER //
// ./assets/scripts/searchform.js